import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Section } from '../../draggable/types';
import { ClientService } from 'src/app/core/admin/_services/client.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { DraggableComponent } from '../../draggable/draggable.component';
import { defaultSections } from '../default-structure';
import { StoreValuationReportTemplatePayload } from '../valuation-report-template.service'

export interface ValuationReportTemplateFormValues {
  name: string,
  client_id: number,
  cover_page_included: boolean,
  toc_included: boolean,
  back_page_included: boolean,
}

@Component({
  selector: 'kt-valuation-report-template-form',
  templateUrl: './valuation-report-template-form.component.html',
  styleUrls: ['./valuation-report-template-form.component.scss']
})
export class ValuationReportTemplateFormComponent {
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    client_id: new FormControl(-1),
    cover_page_included: new FormControl(true),
    toc_included: new FormControl(true),
    back_page_included: new FormControl(true)
  })

  private _sections$ = new BehaviorSubject<Section[]>([])
  sections$ = this._sections$.asObservable()
  @Input()
  set sections(value: Section[]) {
    this._sections$.next(value)
  }

  @Input()
  set formValue(value: ValuationReportTemplateFormValues) {
    if (value === undefined) return;
    this.form.patchValue({
      ...value,
      client_id: value.client_id ?? -1
    })
  }

  @Output() sectionsChanged = new EventEmitter<Section[]>()

  @ViewChild(DraggableComponent) draggableComponent: DraggableComponent;

  clients$ = this.clientService.fetchListing().pipe(
    map(clients => {
      return clients.map(client => ({
        id: client.id,
        name: client.type === 'Company' ? client.name : `${client.name} ${client.last_name}`
      }))
    })
  )

  constructor(
    private clientService: ClientService
  ) {}

  onSectionsChanged(sections: Section[]) {
    this.sectionsChanged.emit(sections)
  }
  onNewSectionClick() {
    this.draggableComponent?.addNewSection()
  }
  onResetSections() {
    this.draggableComponent?.resetSections(defaultSections)
    this.form.patchValue({
      cover_page_included: true,
      toc_included: true,
      back_page_included: true
    })
  }

  validate() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(controlName => {
        if (this.form.controls[controlName].invalid) {
          this.form.controls[controlName].markAsTouched()
        }
      })
      return 'invalid'
    }
    return 'success'
  }

  preparePayload(sections: Section[]): StoreValuationReportTemplatePayload {
    return {
      name: this.form.controls.name.value,
      cover_page_included: this.form.controls.cover_page_included.value,
      toc_included: this.form.controls.toc_included.value,
      back_page_included: this.form.controls.back_page_included.value,
      sections: sections,
      client_id: this.form.controls.client_id.value === -1
        ? null
        : this.form.controls.client_id.value
    }
  }
}